import { IStorageAccessor } from 'util/domain';
import { CommonUtilsService} from 'util/services';

interface MdHeadController {
	order:string;
	onReorder(sortParams:string):void;
}
export function PersistentTableDirective(
	utils:CommonUtilsService,
	storage:IStorageAccessor,
	$state
):ng.IDirective {
	return {
		restrict: 'A',
		priority: 0,
		require: 'mdHead',
		link: function(scope, element, attrs, mdHeadCtrl:MdHeadController) {
			if(!this.name) {
                throw new Error('Cannot get directive name.');
			}

			let id = attrs['id'] || attrs[this.name];
			if(!id){
				// generate an ID based on route and element HTML that should provide
				// sufficient uniqueness while still being reproducible
				id = utils.generateHash(element[0].outerHTML + $state.current.name);
			}

			const storageKey = generateStorageKey(id);
			let sortParams = storage.getStoredValue(storageKey);
			if(sortParams){
				mdHeadCtrl.order = sortParams;
			}

			// intercept call to onReorder to persist
			mdHeadCtrl.onReorder = (originalFn => {
				return (sortParams:string) => {
					storage.setStoredValue(storageKey, sortParams);
					originalFn(sortParams);
				};				
			})(mdHeadCtrl.onReorder || angular.noop);
		}
	};
};

function generateStorageKey(id:string){
	return `table-sort-${id}`;
}

PersistentTableDirective.$inject = [
	'utils',
	'localStorageService',
	'$state'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/persistentTable/persistentTable.ts